// extracted by mini-css-extract-plugin
module.exports = {"title":"Courses_title__3oKve","area":"Courses_area__HGq6d","dropdownManage":"Courses_dropdownManage__3kOAr"};